<template>
    <div>
        <TitlePage :title="$t('edit')+' '+$t('PromoSuperAdminGlobal')"></TitlePage>

        <v-layout wrap v-if="item._id">

            <v-container fluid>
                <v-row>
                    <v-col cols="10">
                        <v-chip class="ma-1" color="red" text-color="white" label>
                            <v-icon left>mdi-stadium</v-icon>
                            {{ item.center[0].name }}
                        </v-chip>
                        <v-chip class="ma-1" color="red" text-color="white" label>
                            <v-icon left>mdi-soccer-field</v-icon>
                            {{ item.field[0].name }}
                        </v-chip>
                        <v-chip class="ma-1" color="red" text-color="white" label>
                            <template v-for="(sport,i) in item.sports_info">
                                {{ sport.name }}<span v-if="i<item.sports_info.length-1">,</span>
                            </template>
                        </v-chip>
                    </v-col>
                    <v-col cols="2">

                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="6" md="2">
                        <div class="pa-2 font-weight-bold box-color-primary">Promo Attiva</div>
                    </v-col>
                    <v-col cols="6" md="1">
                        <v-switch class="mt-2" dense inset hide-details
                                  v-model="item.active"
                                  :color="(this.item.active)?'green':'grey'"
                        ></v-switch>
                    </v-col>
                </v-row>

                <template v-if="this.item.active">
                    <v-row>
                        <v-col cols="12" md="2">
                            <div class="pa-2 font-weight-bold box-color-primary">Tipo di Promo</div>
                        </v-col>
                        <v-col cols="12" md="4" class="align-flex-center">
                            <v-select class="mt-0 pt-0" :items="promotion_types" v-model="item.promo.type"
                                      hide-details/>
                        </v-col>
                        <template v-if="this.item.promo.type != null">
                            <v-col cols="12" md="2">
                                <div class="pa-2 font-weight-bold box-color-primary">Importo Sconto</div>
                            </v-col>
                            <v-col cols="12" md="4" class="align-flex-center">
                                <v-text-field class="mt-0 pt-0" type="number" v-model="item.promo.value"
                                              :prefix="(this.item.promo.type == 'fixed') ? '-':'%'" step="1"
                                              min="0" max="100" hide-details/>
                            </v-col>
                        </template>
                    </v-row>
                    <template v-for="price of this.item.field[0].price">
                        <v-row>
                            <v-col cols="12" md="2">
                                <div class="pa-2 font-weight-bold box-color-primary">Prezzo Std.
                                    {{ getSportName(price.sport_id) }}
                                </div>
                            </v-col>
                            <v-col cols="12" md="2" class="align-flex-center">
                                <div class="font-weight-bold">{{ price.value.toFixed(2) }} €</div>
                            </v-col>
                            <v-col cols="12" md="2">
                                <div class="pa-2 font-weight-bold box-color-primary">Prezzo Promo</div>
                            </v-col>
                            <v-col cols="12" md="2" class="align-flex-center">
                                <div class="font-weight-bold green--text">{{ getPromoPrice(price.value).toFixed(2) }}
                                    €
                                </div>
                            </v-col>
                        </v-row>
                    </template>

                    <v-row>
                        <v-col cols="12" md="2">
                            <div class="pa-2 font-weight-bold box-color-primary">Data Inizio</div>
                        </v-col>
                        <v-col cols="12" md="2" class="align-flex-center">
                            <v-menu
                                    v-model="menu_date_start" :close-on-content-click="false"
                                    transition="scale-transition" offset-y max-width="290px" min-width="auto"
                            >
                                <template v-slot:activator="{ on, attrs }">
                                    <v-text-field v-model="formatDateStart" @click:clear="item.start_time = null"
                                                  readonly v-bind="attrs" v-on="on" hide-details class="mt-0 pt-0"/>
                                </template>
                                <v-date-picker :first-day-of-week="1" v-model="item.start_time" no-title @input="menu_date_start = false"/>
                            </v-menu>
                        </v-col>
                        <v-col cols="12" md="2">
                            <div class="pa-2 font-weight-bold box-color-primary">Data Fine</div>
                        </v-col>
                        <v-col cols="12" md="2" class="align-flex-center">
                            <v-menu
                                    v-model="menu_date_end" :close-on-content-click="false"
                                    transition="scale-transition" offset-y max-width="290px" min-width="auto"
                            >
                                <template v-slot:activator="{ on, attrs }">
                                    <v-text-field :disabled="item.no_end" v-model="formatDateEnd"
                                                  @click:clear="item.end_time = null" readonly v-bind="attrs" v-on="on"
                                                  hide-details class="mt-0 pt-0"/>
                                </template>
                                <v-date-picker v-model="item.end_time" no-title @input="menu_date_end = false" first-day-of-week="1"/>
                            </v-menu>
                        </v-col>
                        <v-col cols="12" md="2">
                            <div class="pa-2 font-weight-bold box-color-primary">Ricorrenza Infinita</div>
                        </v-col>
                        <v-col cols="12" md="1" class="align-flex-center">
                            <v-checkbox
                                    v-model="item.no_end"
                                    color="success"
                                    hide-details
                                    class="mt-0 pt-0"
                            ></v-checkbox>
                        </v-col>
                    </v-row>

                    <v-row>
                        <v-col cols="12" md="2">
                            <div class="pa-2 font-weight-bold box-color-primary">Sconto Dinamico</div>
                        </v-col>
                        <v-col cols="12" md="1">
                            <v-switch class="mt-2" dense inset hide-details
                                      v-model="item.dynamic_promo.active"
                                      :color="(this.item.dynamic_promo.active)?'green':'grey'"
                            ></v-switch>
                        </v-col>
                    </v-row>

                    <template v-if="this.item.dynamic_promo.active">

                        <v-row>
                            <v-col cols="12" md="2">
                                <div class="pa-2 font-weight-bold box-color-primary">Se invenduta per N° GG</div>
                            </v-col>
                            <v-col cols="12" md="2" class="align-flex-center">
                                <v-text-field class="mt-0 pt-0" type="number"
                                              v-model="item.dynamic_promo.num_days_for_start" step="1"
                                              min="0" max="30"/>
                            </v-col>
                            <v-col cols="12" md="2">
                                <div class="pa-2 font-weight-bold box-color-primary">Variazione ogni N° GG</div>
                            </v-col>
                            <v-col cols="12" md="2" class="align-flex-center">
                                <v-text-field class="mt-0 pt-0" type="number" v-model="item.dynamic_promo.num_days_loop"
                                              step="1"
                                              min="0" max="30"/>
                            </v-col>
                            <v-col cols="12" md="2">
                                <div class="pa-2 font-weight-bold box-color-primary">Prezzo Min.</div>
                            </v-col>
                            <v-col cols="12" md="2" class="align-flex-center">
                                <v-text-field class="mt-0 pt-0" type="number" v-model="item.dynamic_promo.min_price"
                                              prefix="€"
                                              step="0.50"/>
                            </v-col>
                        </v-row>

                        <v-row>
                            <v-col cols="12" md="2">
                                <div class="pa-2 font-weight-bold box-color-primary">Tipo di Promo</div>
                            </v-col>
                            <v-col cols="12" md="4" class="align-flex-center">
                                <v-select class="mt-0 pt-0" :items="promotion_types" v-model="item.dynamic_promo.type"
                                          hide-details/>
                            </v-col>
                            <template v-if="this.item.dynamic_promo.type != null">
                                <v-col cols="12" md="2">
                                    <div class="pa-2 font-weight-bold box-color-primary">Importo Sconto</div>
                                </v-col>
                                <v-col cols="12" md="4" class="align-flex-center">
                                    <v-text-field class="mt-0 pt-0" type="number" v-model="item.dynamic_promo.value"
                                                  :prefix="(this.item.dynamic_promo.type == 'fixed') ? '-':'%'" step="1"
                                                  min="0" max="100" hide-details/>
                                </v-col>
                            </template>
                        </v-row>

                    </template>

                    <v-row>
                        <v-col cols="12" md="3">
                            <div class="pa-2 font-weight-bold box-color-primary">Eccezioni sul Calendario Master</div>
                        </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="12" md="12" class="pt-0 mt-0" style="font-size: 13px">
                        <v-icon color="red">
                          mdi-close-thick
                        </v-icon> Se l'icona è rossa, significa che la Promo SA non sarà attivata sullo slot di riferimento
                        <br/>
                        <v-icon color="red">
                          mdi-timer-off
                        </v-icon> Se l'icona è rossa, significa che la Promo SA non applicherà sconti dinamici sullo slot di riferimento
                      </v-col>
                        <v-col cols="12">
                            <v-simple-table dense v-if="item.field[0].master_calendar">
                                <thead>
                                <tr>
                                    <th v-for="header in headers" :key="'head_'+header.name" style="padding-left: 4%">
                                        {{ header.name }}
                                    </th>
                                </tr>
                                </thead>
                                <tbody>
                                <tr class="" v-for="(slot, slot_index) in this.master_calendar_depth"
                                    :key="'time_slot'+slot_index">
                                    <template v-for="header in headers"
                                              v-if="item.field[0].master_calendar[header.day][slot_index]">
                                        <td>
                                            <v-chip small
                                                    :color="(item.field[0].master_calendar[header.day][slot_index].active) ? 'green':'gray'"
                                                    :text-color="(item.field[0].master_calendar[header.day][slot_index].active) ? 'white':'gray'"
                                            >
                                                {{ item.field[0].master_calendar[header.day][slot_index].start }} -
                                                {{ item.field[0].master_calendar[header.day][slot_index].end }}
                                            </v-chip>
                                            <template v-if="item.field[0].master_calendar[header.day][slot_index].active">
                                                <template
                                                        v-if="checkIfPromoGlobalDisabled(header.day,item.field[0].master_calendar[header.day][slot_index])">
                                                    <v-icon color="red"
                                                            @click="excludeSlotFromPromo(header.day,item.field[0].master_calendar[header.day][slot_index])">
                                                        mdi-close-thick
                                                    </v-icon>
                                                </template>
                                                <template v-else>
                                                    <v-icon @click="excludeSlotFromPromo(header.day,item.field[0].master_calendar[header.day][slot_index])">
                                                        mdi-close-outline
                                                    </v-icon>
                                                </template>
                                                <template v-if="item.dynamic_promo.active">
                                                    <template
                                                            v-if="checkIfPromoGlobalDynamicDisabled(header.day,item.field[0].master_calendar[header.day][slot_index])">
                                                        <v-icon color="red"
                                                                @click="excludeDynamicFromSlot(header.day,item.field[0].master_calendar[header.day][slot_index])">
                                                            mdi-timer-off
                                                        </v-icon>
                                                    </template>
                                                    <template v-else>
                                                        <v-icon @click="excludeDynamicFromSlot(header.day,item.field[0].master_calendar[header.day][slot_index])">
                                                            mdi-timer-outline
                                                        </v-icon>
                                                    </template>
                                                </template>
                                            </template>
                                        </td>
                                    </template>
                                    <template v-else>
                                        <td class="ma-0 pa-0 text-center">
                                            -
                                        </td>
                                    </template>
                                </tr>
                                </tbody>
                            </v-simple-table>
                        </v-col>
                    </v-row>

                </template>

            </v-container>

            <v-flex md12 class="pt-10 d-flex">
                <v-divider class="marg-title"></v-divider>
            </v-flex>
            <v-flex md12 class="pt-5 d-flex buttons-group-mobile">
                <v-btn elevation="2" color="" class="mr-auto" @click="goBack">
                    <v-icon left>mdi-keyboard-backspace</v-icon>
                    {{ $t('back') }}
                </v-btn>
                <v-btn elevation="2" color="primary" class="ml-auto" @click="update" type="submit">
                    {{ $t('save') }}
                    <v-icon right>mdi-content-save</v-icon>
                </v-btn>
            </v-flex>

        </v-layout>
    </div>
</template>

<script>
import TitlePage from "@/components/utils/TitlePage";
import {mapActions, mapGetters, mapMutations} from 'vuex';

const slugify = require('slugify')

export default {
    name: "EditPromoSuperAdminGlobal",
    components: {TitlePage},
    computed: {
        ...mapGetters({
            'getUser': 'user/getUser'
        }),
        formatDateStart() {
            return this.formatDate(this.item.start_time)
        },
        formatDateEnd() {
            return this.formatDate(this.item.end_time)
        },

    },
    data() {
        return {
            item: {},
            menu_date_start: false,
            menu_date_end: false,
            promotion_types: [
                {'text': '', 'value': null},
                {'text': this.$t('fixed'), 'value': 'fixed'},
                {'text': this.$t('percentage'), 'value': 'percentage'},
            ],
            headers: [
                {name: 'Lunedì', day: 1},
                {name: 'Martedì', day: 2},
                {name: 'Mercoledì', day: 3},
                {name: 'Giovedì', day: 4},
                {name: 'Venerdì', day: 5},
                {name: 'Sabato', day: 6},
                {name: 'Domenica', day: 0},
            ],
            master_calendar_depth: 0,
            check: true,
            errors: {},
            validation: {
                textRules: [
                    v => !!v || this.$t('fillMandatory'),
                ]
            }
        };
    },
    async created() {
        if (!this.getUser.super_admin) {
            this.$router.push('/')
            return
        }
        this.setLoading(true);
        let item = await this.editItem(this.$route.params)
        this.item = item.result
        for (let i = 0; i < 7; i++) {
            if (item.result.field[0].master_calendar[i].length > this.master_calendar_depth) {
                this.master_calendar_depth = item.result.field[0].master_calendar[i].length
            }
        }
        this.setLoading(false);
    },
    methods: {
        ...mapMutations({
            'setLoading': 'settings/setLoading',
            'setNotification': 'settings/setNotification',
        }),
        ...mapActions({
            'editItem': 'promoSAGlobal/edit',
            'updateItem': 'promoSAGlobal/update',
        }),
        async goBack(){
          let url = '/promo-sa-global?center_id='+this.item.center_id
          this.$router.push(url)
        },
        async update() {

            await this.checkItem()
            if (!this.check) {
                return
            } else {
                await this.resetError()
            }

            await this.setLoading(true);
            let result = await this.updateItem({...this.$route.params, item: this.item})
            await this.setLoading(false);

            if (result.success) {

                this.setNotification({
                    active: true,
                    color: 'success',
                    mode: 'multi-line',
                    text: this.$t('updateSuccess')
                })

            } else {

                this.setNotification({
                    active: true,
                    color: 'error',
                    mode: 'multi-line',
                    text: result
                })

            }


        },

        async checkItem() {
            this.check = true
        },

        async resetError() {
            this.errors = {}
        },

        getSportName(id) {
            let find = this.item.sports_info.find((o) => o._id === id)
            return (find) ? find.name : ''
        },

        getPromoPrice(price) {
            if (!this.item.promo.type) {
                return price
            } else {
                if (this.item.promo.type === 'fixed') {
                    return price - this.item.promo.value
                } else {
                    let unit = _.round(+price / 100, 3);
                    let discount = _.round(+unit * (+this.item.promo.value), 2);
                    return _.round(+price - discount, 2)
                }
            }
        },
        formatDate(date) {
            if (!date) return null
            const [year, month, day] = date.split('-')
            let day_fixed = (day.includes('T')) ? day.split('T')[0] : day
            return `${day_fixed}/${month}/${year}`
        },
        checkIfPromoGlobalDisabled(day, timeslot) {
            if (!this.item.slots_excluded_promo_sa) {
                this.item.slots_excluded_promo_sa = []
                this.item.slots_excluded_promo_sa[0] = []
                this.item.slots_excluded_promo_sa[1] = []
                this.item.slots_excluded_promo_sa[2] = []
                this.item.slots_excluded_promo_sa[3] = []
                this.item.slots_excluded_promo_sa[4] = []
                this.item.slots_excluded_promo_sa[5] = []
                this.item.slots_excluded_promo_sa[6] = []
                this.item.slots_excluded_promo_sa[7] = []
                return false
            } else {
                let check = _.find(this.item.slots_excluded_promo_sa[day], {'id': timeslot.id})
                return !!check;
            }
        },
        checkIfPromoGlobalDynamicDisabled(day, timeslot) {
            if (!this.item.slots_excluded_promo_dynamic) {
                this.item.slots_excluded_promo_dynamic = []
                this.item.slots_excluded_promo_dynamic[0] = []
                this.item.slots_excluded_promo_dynamic[1] = []
                this.item.slots_excluded_promo_dynamic[2] = []
                this.item.slots_excluded_promo_dynamic[3] = []
                this.item.slots_excluded_promo_dynamic[4] = []
                this.item.slots_excluded_promo_dynamic[5] = []
                this.item.slots_excluded_promo_dynamic[6] = []
                this.item.slots_excluded_promo_dynamic[7] = []
                return false
            } else {
                let check = _.find(this.item.slots_excluded_promo_dynamic[day], {'id': timeslot.id})
                return !!check;
            }
        },
        excludeSlotFromPromo(day, timeslot) {
            let time_primitive = JSON.parse(JSON.stringify(timeslot))
            let check = _.findIndex(this.item.slots_excluded_promo_sa[day], {'id': time_primitive.id})
            if (check === -1) {
                this.item.slots_excluded_promo_sa[day].push(time_primitive)
            } else {
                this.item.slots_excluded_promo_sa[day].splice(check, 1)
            }

            this.$forceUpdate();
        },
        excludeDynamicFromSlot(day, timeslot) {
            let time_primitive = JSON.parse(JSON.stringify(timeslot))
            let check = _.findIndex(this.item.slots_excluded_promo_dynamic[day], {'id': time_primitive.id})
            if (check === -1) {
                this.item.slots_excluded_promo_dynamic[day].push(time_primitive)
            } else {
                this.item.slots_excluded_promo_dynamic[day].splice(check, 1)
            }

            this.$forceUpdate();
        },

    },
    mounted() {

    },
}
</script>

<style scoped>
.box-color-primary {
    background: #222b54;
    color: white;
    border-radius: 3px;
    font-size: 13px;
}

.align-flex-center {
    align-items: center;
    display: flex;
}

</style>